import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { useState } from 'react';
import { Faq } from 'shared/components/Faq';
import { IFaqSection, TFaqData } from 'shared/types/faq';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const FaqContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const device = useDeviceType();

  const { state: modalVisible, toggle: toggleModalVisible } = useToggleState();

  const [activeFaq, setActiveFaq] = useState<IFaqSection>({ title: '', faq: [] });

  const faq = config.getStrict<TFaqData>('b2b-marketing-cpc-frontend.faq');

  const handleActiveFaq = (faq: IFaqSection) => {
    toggleModalVisible();
    setActiveFaq(faq);
  };

  return (
    <Faq
      device={device}
      faq={faq}
      activeFaq={activeFaq}
      handleActiveFaq={handleActiveFaq}
      modalVisible={modalVisible}
      toggleModalVisible={toggleModalVisible}
    />
  );
};
